import { css, Modal, Stack, Typography, useMediaQuery } from '@mui/material'
import { useTranslation } from 'next-i18next'
import { useContext } from 'react'
import FilterIcon from 'assets/icons/nucleo/18px_filter.svg'
import XMarkIcon from 'assets/icons/nucleo/18px_xmark.svg'
import { Drawer } from 'components/Layout/Header/Header.style'
import { Button, ButtonVariant } from 'components/common/Button'
import { ClearRefinements } from 'containers/search/ClearRefinements'
import { raceCategoriesLevel1 } from 'helpers/raceCategoryLevels'
import { recordKeys } from 'helpers/records'
import { themeUtils } from 'styles/theme'
import { FilterCategory } from './FilterCategory'
import { FiltersBox } from './Filters.style'
import { FiltersContext } from './FiltersContext'

interface FiltersProps {
  open: boolean
  setOpen: (open: boolean) => void
}

export const Filters = ({ open, setOpen }: FiltersProps) => {
  const { t } = useTranslation('home')
  const isMobile = useMediaQuery(themeUtils.maxWidth.md)
  const { filters, applyFilters, currentRefinementValues } =
    useContext(FiltersContext)

  const handleApply = () => {
    applyFilters()
    setOpen(false)
  }

  const MainComponent = isMobile ? Drawer : Modal

  return (
    <>
      <Button
        variant={ButtonVariant.Quaternary}
        label={t('filters.title')}
        leftIcon={
          <FilterIcon
            css={css`
              max-width: 18px;
            `}
          />
        }
        onClick={() => setOpen(true)}
      />
      <MainComponent open={open} onClose={() => setOpen(false)}>
        <FiltersBox>
          <Stack
            px={3}
            py={1.5}
            flexDirection="row"
            justifyContent="space-between"
            css={css`
              ${themeUtils.maxWidth.md} {
                padding-top: 24px;
                padding-bottom: 17px;
              }
            `}
          >
            <Typography variant="h4">
              {t('filters.title')} ({currentRefinementValues.length})
            </Typography>
            <XMarkIcon
              style={{ transform: 'scale(1.225)', cursor: 'pointer' }}
              onClick={() => setOpen(false)}
            />
          </Stack>
          <Stack maxHeight={{ md: '60vh', xs: 'none' }} overflow="auto">
            <Stack px={2} py={1.5} gap={3}>
              {recordKeys(raceCategoriesLevel1).map((type) => (
                <FilterCategory
                  key={type}
                  title={type}
                  filters={filters.filter((item) =>
                    [...raceCategoriesLevel1[type].level2Categories].includes(
                      item.key
                    )
                  )}
                  initiallyVisibleCount={2}
                />
              ))}
            </Stack>
          </Stack>

          <Stack
            px={2.5}
            py={2}
            gap={1}
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Stack flex={1}>
              <ClearRefinements close={() => setOpen(false)} />
            </Stack>
            <Stack flex={1}>
              <Button
                fullWidth
                variant={ButtonVariant.Primary}
                label={t('head.apply')}
                onClick={handleApply}
              />
            </Stack>
          </Stack>
        </FiltersBox>
      </MainComponent>
    </>
  )
}
